import { colors } from '../../../../../colors';
import {
  useGetCandleFetcherQueuesQuery,
  useGetExchangeQueuesQuery,
} from '../../../../../store/services/api';
import { FiRefreshCw } from 'react-icons/fi';

const Queues = () => {
  const { data: exchangeQueue, refetch: refetchExchangeQueue } =
    useGetExchangeQueuesQuery(undefined);
  const { data: candleFetcherQueue, refetch: refetchCandleFetcherQueue } =
    useGetCandleFetcherQueuesQuery(undefined);

  const refetch = () => {
    refetchExchangeQueue();
    refetchCandleFetcherQueue();
  };

  return (
    <div
      style={{
        color: colors.white,
        padding: 32,
        flex: 1,
        position: 'relative',
      }}
    >
      <p
        style={{
          fontSize: 24,
          fontWeight: 'bold',
          marginTop: 0,
          marginBottom: 0,
        }}
      >
        Exchange Queues
      </p>
      <div>
        {Object.entries(exchangeQueue?.queues || {}).map(
          ([exchange, queue]) => {
            if (!queue?.length) {
              return null;
            }

            return (
              <div key={exchange}>
                <p
                  style={{
                    fontSize: 18,
                    textTransform: 'capitalize',
                  }}
                >
                  {exchange.toLowerCase()}
                </p>
                <div>
                  {queue.map((q, i) => (
                    <div key={`${exchange}_${i}`}>
                      <p>{JSON.stringify(q)}</p>
                    </div>
                  ))}
                </div>
              </div>
            );
          },
        )}
        <p
          style={{
            fontSize: 24,
            fontWeight: 'bold',
            marginBottom: 0,
          }}
        >
          Candle Fetcher Queues
        </p>
        {Object.entries(candleFetcherQueue || {}).map(([index, params]) => {
          if (!params?.length) {
            return null;
          }

          return (
            <div key={index}>
              <p
                style={{
                  fontSize: 18,
                }}
              >
                {index}
              </p>
              <p>{JSON.stringify(params)}</p>
            </div>
          );
        })}
      </div>
      <div style={{ position: 'absolute', top: 32, right: 16 }}>
        <FiRefreshCw
          color={colors.gray}
          size={24}
          onClick={refetch}
          style={{ cursor: 'pointer' }}
        />
      </div>
    </div>
  );
};

export default Queues;
